module["exports"] = [
  "####",
  "####",
  "####",
  "0###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nb_NO/address/postcode.js
 ** module id = 833
 ** module chunks = 0
 **/